var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-col", { staticClass: "mt-2" }, [
    _c(
      "div",
      {
        staticClass: "accordion",
        staticStyle: { width: "100%" },
        attrs: { role: "tablist" }
      },
      [
        _c(
          "div",
          { staticClass: "accordion-wrapper" },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "b-toggle",
                    rawName: "v-b-toggle",
                    value: `${_vm.id}-features`,
                    expression: "`${id}-features`"
                  }
                ]
              },
              [
                _c(
                  "div",
                  { staticClass: "row align-items-center no-gutters" },
                  [
                    _c("div", { staticClass: "col d-flex" }, [
                      _c("i", {
                        class: `fa-fw fa-check-circle check-icon mr-2 ${
                          _vm.isCovered ? "fas" : "far"
                        }`
                      }),
                      _c("div", [
                        _c("p", { staticClass: "mb-0" }, [
                          _vm._v(_vm._s(_vm.generatorName))
                        ]),
                        _c("p", { staticClass: "receives-features-text" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.isCovered
                                  ? _vm.$t("xReceivesPremiumFeatures")
                                  : _vm.$t("xNotIncludedInPlan")
                              ) +
                              " "
                          )
                        ])
                      ])
                    ]),
                    _c("div", { staticClass: "col-auto" }, [
                      _c("i", {
                        staticClass: "fas fa-chevron-down when-closed"
                      }),
                      _c("i", { staticClass: "fas fa-chevron-up when-open" })
                    ])
                  ]
                )
              ]
            ),
            _c("b-collapse", { attrs: { id: `${_vm.id}-features` } }, [
              _c("div", { staticClass: "features" }, [
                _c("div", { staticClass: "basic" }, [
                  _c("p", { staticClass: "mb-1" }, [
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.$t("xFeaturesIncludedInPlan")) +
                          _vm._s(_vm.$t("xBasic"))
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "feature" }, [
                    _c("i", { staticClass: "far fa-fw fa-clipboard-list" }),
                    _c("div", [
                      _c("p", { staticClass: "basic-features" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "xFeaturesIncludedWiFiAnnuallySubscriptionFeature1"
                              )
                            ) +
                            " "
                        )
                      ])
                    ])
                  ])
                ]),
                _c("div", { staticClass: "premium" }, [
                  _c("p", { staticClass: "mb-1" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.$t("xAdditionalFeatuesInPremium")))
                    ])
                  ]),
                  _c("div", { staticClass: "feature" }, [
                    _c("i", { staticClass: "far fa-fw fa-bell" }),
                    _c("div", { staticClass: "mb-2" }, [
                      _c("p", { staticClass: "premium-feature-text" }, [
                        _vm._v(" " + _vm._s(_vm.$t("xRealTimeAlerts")) + " ")
                      ]),
                      _c(
                        "p",
                        { staticClass: "premium-feature-supporting-text" },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("xRealTimeAlertsDesc")) + " "
                          )
                        ]
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "feature" }, [
                    _c("i", { staticClass: "far fa-fw fa-calendar" }),
                    _c("div", { staticClass: "mb-2" }, [
                      _c("p", { staticClass: "premium-feature-text" }, [
                        _vm._v(" " + _vm._s(_vm.$t("xExerciseSettings")) + " ")
                      ]),
                      _c(
                        "p",
                        { staticClass: "premium-feature-supporting-text" },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("xExerciseSettingsDesc")) + " "
                          )
                        ]
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "feature" }, [
                    _c("i", { staticClass: "far fa-fw fa-arrows-spin" }),
                    _c("div", { staticClass: "mb-2" }, [
                      _c("p", { staticClass: "premium-feature-text" }, [
                        _vm._v(" " + _vm._s(_vm.$t("xExerciseOnDemand")) + " ")
                      ]),
                      _c(
                        "p",
                        { staticClass: "premium-feature-supporting-text" },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("xExerciseOnDemandDesc")) + " "
                          )
                        ]
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "feature" }, [
                    _c("i", { staticClass: "far fa-fw fa-warning" }),
                    _c("div", [
                      _c("p", { staticClass: "premium-feature-text" }, [
                        _vm._v(" " + _vm._s(_vm.$t("xDismissWarnings")) + " ")
                      ]),
                      _c(
                        "p",
                        { staticClass: "premium-feature-supporting-text" },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("xDismissWarningsDesc")) + " "
                          )
                        ]
                      )
                    ])
                  ])
                ])
              ])
            ])
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }